import { render } from "./table-row.vue?vue&type=template&id=889da8ec&ts=true"
import script from "./table-row.vue?vue&type=script&lang=ts"
export * from "./table-row.vue?vue&type=script&lang=ts"

import "./table-row.vue?vue&type=style&index=0&id=889da8ec&lang=css"

import exportComponent from "/working_dir/Loupey.WebApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__